$('select[name="per_page"]').on('change', (e) => {
  changeParams({per_page: e.target.value})
});
